import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useViewSlotOccurrence } from '../../hooks/useViewSlotOccurrence';

export const ModifySlotOverlapToast = memo(function ModifySlotOverlapToast({
    overlappedSlotId,
}: {
    overlappedSlotId: string;
}) {
    const viewInGantt = useViewSlotOccurrence(overlappedSlotId);
    return (
        <div onClick={viewInGantt}>
            <FormattedMessage id={'requestForm.overlapToast'} />
        </div>
    );
});
